
       const __ReactNativeSvgLoader = require('react-native-svg-transformer-fix-expo').default({
  "replaceAttrValues": {
    "#000": "{props.color}"
  }
});
        import { ActivityIndicator, AutoHeightInput, Flex, Pressable, UserAvatar, View, Ionicons } from '@ui/atoms';
import useTranslate from '@hooks/useTranslate';
import { useState } from 'react';

  const PaperPlane = __ReactNativeSvgLoader(import('@src/assets/icons/paperPlaneRight.svg'));
  ;
import useThemeColor from '@hooks/useThemeColor';
import CustomPropTypes from '@utils/CustomPropTypes';
import useCommentMutation from '@hooks/mutations/useCommentMutation';
import useToast from '@hooks/useToast';
import { Keyboard, Platform } from 'react-native';
import PropTypes from 'prop-types';
import useMeQuery from '@hooks/queries/useMeQuery';
import COMMENTABLE_MODEL from '@constants/CommentableModel';
import MAX_LENGTH from '@constants/MaxLength';
import useUploadMutation from '@hooks/mutations/useUploadMutation';
import ImagesPicker from '@ui/organisms/ImagesPicker';

function AddComment({ model, inputRef = undefined, onFocus = undefined, sx = undefined }) {
  const { t } = useTranslate();
  const primaryColor = useThemeColor('$primary.main');
  const toast = useToast();

  const { data: me } = useMeQuery();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');
  const [height, setHeight] = useState('auto');
  const [images, setImages] = useState([]);
  const [showImagesPicker, setShowImagesPicker] = useState(false);

  const { mutateAsync } = useCommentMutation();
  const { mutate: uploadImage, isLoading: uploadingImage } = useUploadMutation({
    onSuccess: (res) => {
      setImages((prev) => [
        ...prev,
        {
          id: res.data.id,
          uri: res.data.preview ?? res.data.small,
        },
      ]);
    },
    onError: (err) => {
      if (422 === err.response?.status) {
        toast.error(err.response.data.errors?.file[0] || 'Format de fichier non supporté');
      } else {
        toast.error(t('errors.api.default'));
      }
    },
  });

  const handleSubmit = async () => {
    try {
      setLoading(true);

      await mutateAsync({
        comment: value,
        model,
        ...(images.length > 0 && { images: images.map((img) => img.id) }),
      });

      if (Platform.OS === 'ios') {
        // Autocorrect on iOS may re-set the value if we clear before the keyboard is closed.
        setTimeout(() => {
          setValue('');
          setImages([]);
        }, 300);
      } else {
        setValue('');
        setImages([]);
      }
    } catch (err) {
      toast.error(t('errors.api.default'));
    } finally {
      setLoading(false);
      Keyboard.dismiss();
    }
  };

  const handleDeleteImage = (imageToDelete) => {
    setImages((prev) => prev.filter((img) => img.id !== imageToDelete.id));
  };

  const handleToggleImagesPicker = () => {
    setShowImagesPicker(!showImagesPicker);
  };

  return (
    <View sx={sx}>
      <Flex alignItems="center">
        <UserAvatar sx={{ mr: '$4' }} size="medium" user={me} />
        <AutoHeightInput
          onFocus={onFocus}
          color="grey"
          maxHeight={100}
          value={value}
          onChangeText={(val) => setValue(val)}
          placeholder={t('ui.AddComment.comment')}
          viewProps={{ sx: { flex: 1 } }}
          ref={inputRef}
          onHeightChange={setHeight}
          maxLength={MAX_LENGTH.comment}
          endIcon={loading ? <ActivityIndicator color={primaryColor} /> : null}
          withCharCounter
        />
        <Pressable onPress={handleToggleImagesPicker} sx={{ height, justifyContent: 'center', mr: '$1', ml: '$1' }}>
          <Ionicons name="camera" size={24} color={primaryColor} />
        </Pressable>
        <Pressable
          onPress={handleSubmit}
          disabled={value.length === 0}
          sx={{ height, justifyContent: 'center', mr: '$1', ml: '$1' }}
        >
          <PaperPlane color={primaryColor} height={24} width={24} />
        </Pressable>
      </Flex>

      {showImagesPicker && (
        <View sx={{ mt: '$6', width: '100%' }}>
          <ImagesPicker
            images={images.map((image) => ({
              id: image.id,
              uri: image.uri,
            }))}
            max={5}
            loading={uploadingImage}
            onSelect={uploadImage}
            onDelete={handleDeleteImage}
          />
        </View>
      )}
    </View>
  );
}

AddComment.propTypes = {
  model: PropTypes.exact({
    type: PropTypes.oneOf(Object.values(COMMENTABLE_MODEL)),
    id: CustomPropTypes.uuid,
  }).isRequired,
  inputRef: CustomPropTypes.ref,
  onFocus: PropTypes.func,
  sx: CustomPropTypes.style,
};

export default AddComment;

        